import styled from "styled-components";

import theme from "../../../theme";

export const ErrorComponent = styled.div`
  color: ${theme.colors.red};
  font-size: ${theme.fontSizes.small};
  letter-spacing: 0.47pt;
`;

export default ErrorComponent;
